/**
 * Product page (sections/hg-product.liquid): strength cards, plan cards,
 * gallery, in-page nav, FAQ. Plain script (no modules), runs after parse via
 * defer. Loaded by the section only, so it ships on product pages alone.
 */
(function() {
  var roots = document.querySelectorAll('[data-hg-product]');
  if (!roots.length) return;

  roots.forEach(function(root) {
    // ===== Product data (variants) injected into a JSON script tag =====
    // The script tag lives outside <section>, so query from document.
    var variantsData = document.querySelector('[data-variants-json]');
    var variants = [];
    if (variantsData) {
      try { variants = JSON.parse(variantsData.textContent); } catch (e) { variants = []; }
    }

    var radios = root.querySelectorAll('[data-variant-radio]');
    var variantIdInput = root.querySelector('[data-variant-id]');
    var ctaBtn = root.querySelector('[data-add-to-cart]');
    var ctaLabel = root.querySelector('[data-cta-label]');

    // Whole dollars drop the cents ("$205"), matching money_without_trailing_zeros.
    function formatMoney(cents) {
      if (typeof cents !== 'number') return '';
      var dollars = cents / 100;
      var whole = Math.round(dollars) === dollars;
      return '$' + (whole ? dollars.toFixed(0) : dollars.toFixed(2)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    // ===== Plans (Shopify Subscriptions selling plans) =====
    // Each plan radio carries the months one charge covers; the price of
    // every plan for every variant rides in the data-plans-json map.
    var planRadios = root.querySelectorAll('[data-plan-radio]');
    var planPrices = {};
    var planPricesEl = root.querySelector('[data-plans-json]');
    if (planPricesEl) {
      try { planPrices = JSON.parse(planPricesEl.textContent); } catch (e) { planPrices = {}; }
    }

    function planPrice(variant, planId) {
      var price = (planPrices[String(variant.id)] || {})[String(planId)];
      return typeof price === 'number' ? price : null;
    }

    function monthlyPlanPrice(variant) {
      var found = 0;
      planRadios.forEach(function(radio) {
        if (radio.dataset.planMonths !== '1') return;
        var price = planPrice(variant, radio.value);
        if (price !== null) found = price;
      });
      return found;
    }

    // One plan card's price line: what is charged and how often. The price
    // block spells the selected plan out in full. Mirrors the Liquid render.
    function planLine(price, months) {
      if (months === 1) return formatMoney(price) + ' a month';
      if (months === 3) return formatMoney(price) + ' every 3 months';
      return formatMoney(price) + ', one payment';
    }

    // The headline price: figure, cadence label (null = leave as rendered), line under it.
    function describe(price, months, saving) {
      if (!planRadios.length) return { big: formatMoney(price), label: null, sub: '' };
      if (months === 1) return { big: formatMoney(price), label: '/ month', sub: '' };
      if (months === 3) {
        return { big: '$' + Math.round(price / 300), label: '/mo', sub: 'Billed ' + formatMoney(price) + ' every 3 months' };
      }
      return {
        big: formatMoney(price),
        label: 'one payment',
        sub: months + ' months of treatment' + (saving > 0 ? ' · save ' + formatMoney(saving) : '')
      };
    }

    // Per-day anchor: price / days one charge covers, to the cent, trailing zeros dropped.
    function formatPerDay(cents, months) {
      if (typeof cents !== 'number') return '';
      var perDay = Math.round(cents / (30 * (months || 1))) / 100;
      var whole = Math.round(perDay) === perDay;
      return '$' + (whole ? perDay.toFixed(0) : perDay.toFixed(2));
    }

    function setText(selector, text) {
      root.querySelectorAll(selector).forEach(function(el) { el.textContent = text; });
    }

    function selectedVariant() {
      var checked = root.querySelector('[data-variant-radio]:checked');
      // Products with one variant have no strength cards.
      if (!checked) return variants[0] || null;
      return variants.find(function(v) { return String(v.id) === String(checked.value); }) || null;
    }

    function updateUI(updateUrl) {
      var variant = selectedVariant();
      if (!variant) return;

      root.querySelectorAll('[data-variant-radio], [data-plan-radio]').forEach(function(radio) {
        var card = radio.closest('.hg-pdp__card');
        if (card) card.classList.toggle('is-selected', radio.checked);
      });

      if (variantIdInput) variantIdInput.value = variant.id;

      // Description line under the strength grid.
      root.querySelectorAll('[data-desc-for]').forEach(function(desc) {
        desc.hidden = desc.dataset.descFor !== String(variant.id);
      });

      // Price: from the selected plan when plans exist, else the variant.
      var price = variant.price;
      // Without plans, the months one charge covers come from the product's
      // billing tag (rendered on the per-day line), e.g. 3 for quarterly.
      var perDayEl = root.querySelector('[data-price-per-day]');
      var months = (perDayEl && parseInt(perDayEl.dataset.months, 10)) || 1;
      var saving = 0;
      if (planRadios.length) {
        var monthly = monthlyPlanPrice(variant);
        planRadios.forEach(function(radio) {
          var card = radio.closest('.hg-pdp__card');
          var rowPrice = planPrice(variant, radio.value);
          var rowMonths = parseInt(radio.dataset.planMonths, 10) || 1;
          if (!card) return;
          card.hidden = rowPrice === null;
          if (rowPrice === null) return;
          var line = card.querySelector('[data-plan-line]');
          if (line) line.textContent = planLine(rowPrice, rowMonths);
          var rowSaving = rowMonths > 3 && monthly > 0 ? monthly * rowMonths - rowPrice : 0;
          var save = card.querySelector('[data-plan-save]');
          if (save) {
            save.hidden = rowSaving <= 0;
            save.textContent = 'Save ' + formatMoney(rowSaving);
          }
          if (radio.checked) {
            price = rowPrice;
            months = rowMonths;
            saving = rowSaving;
          }
        });
      }
      var shown = describe(price, months, saving);

      setText('[data-price]', shown.big);
      setText('[data-final-price]', shown.big);
      if (shown.label !== null) {
        setText('[data-price-cadence]', shown.label);
        setText('[data-final-cadence]', shown.label.toUpperCase());
      }

      // Sticky bars: what one charge is ("$119 / 3 months"), never the
      // per-month figure alone, and the selected dose without its "(...)" note.
      if (planRadios.length && months === 3) {
        setText('[data-sticky-price]', formatMoney(price));
        setText('[data-sticky-cadence]', ' / 3 months');
      } else {
        setText('[data-sticky-price]', shown.big);
        if (shown.label !== null) setText('[data-sticky-cadence]', ' ' + shown.label);
      }
      setText('[data-sticky-variant]', String(variant.title || '').split(' (')[0]);
      root.querySelectorAll('[data-price-billed]').forEach(function(el) {
        el.textContent = shown.sub;
        el.hidden = !shown.sub;
      });
      setText('[data-price-per-day]', 'About ' + formatPerDay(price, months) + ' a day');

      var label = variant.available
        ? (ctaBtn && ctaBtn.dataset.ctaAvailableLabel) || 'Add to cart'
        : (ctaBtn && ctaBtn.dataset.ctaSoldoutLabel) || 'Sold out';
      if (ctaBtn) ctaBtn.disabled = !variant.available;
      if (ctaLabel) ctaLabel.textContent = label;
      var stickyBtn = root.querySelector('[data-sticky-cta-btn]');
      if (stickyBtn) stickyBtn.disabled = !variant.available;
      setText('[data-sticky-cta-label]', label);

      if (updateUrl && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    radios.forEach(function(radio) {
      radio.addEventListener('change', function() { updateUI(true); });
    });
    planRadios.forEach(function(radio) {
      radio.addEventListener('change', function() { updateUI(false); });
    });

    // ===== Usual start: pre-select on load =====
    // A variant flagged as the usual start wins over "first available" unless
    // the URL already names a variant (?variant=, e.g. a quiz deep link).
    var urlNamesVariant = /[?&]variant=/.test(window.location.search);
    var usual = root.querySelector('[data-variant-radio][data-usual-start]');
    if (!urlNamesVariant && usual && !usual.checked) {
      usual.checked = true;
      updateUI(false);
    }

    // ===== Gallery =====
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
    var frames = root.querySelectorAll('[data-frame]');

    function showFrame(index) {
      frames.forEach(function(frame) {
        frame.classList.toggle('is-active', frame.dataset.frame === String(index));
      });
      thumbs.forEach(function(thumb) {
        var active = thumb.dataset.thumb === String(index);
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    thumbs.forEach(function(thumb, i) {
      thumb.addEventListener('click', function() { showFrame(thumb.dataset.thumb); });
      thumb.addEventListener('keydown', function(e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        var next = thumbs[(i + (e.key === 'ArrowRight' ? 1 : thumbs.length - 1)) % thumbs.length];
        next.focus();
        showFrame(next.dataset.thumb);
      });
    });

    // ===== Add to cart without leaving the page =====
    // "Start your protocol" (and the sticky bars, which submit the same form)
    // adds in the background, refreshes the cart drawer and opens it, like
    // Gymshark: Checkout is one tap away and closing it returns to the page.
    // The drawer listens for 'cart:update' (assets/component-cart-items.js
    // re-renders, assets/cart-drawer.js auto-opens, assets/cart-icon.js updates
    // the bubble). Any failure falls back to the plain form submit, which
    // goes to /cart exactly as before.
    var buyForm = root.querySelector('[data-hg-form]');
    if (buyForm && window.fetch && window.FormData) {
      var adding = false;
      var buyButtons = function() {
        return document.querySelectorAll('[data-add-to-cart], [data-sticky-cta-btn]');
      };
      var setBusy = function(on) {
        buyButtons().forEach(function(btn) {
          if (on) {
            btn.dataset.hgWasDisabled = btn.disabled ? '1' : '';
            btn.disabled = true;
            btn.setAttribute('aria-busy', 'true');
          } else {
            btn.disabled = btn.dataset.hgWasDisabled === '1';
            btn.removeAttribute('aria-busy');
          }
        });
      };
      var nativeSubmit = function() {
        HTMLFormElement.prototype.submit.call(buyForm);
      };

      buyForm.addEventListener('submit', function(e) {
        var drawer = document.querySelector('cart-drawer-component');
        var cartItems = drawer && drawer.querySelector('cart-items-component[data-section-id]');
        if (!drawer || !cartItems || typeof drawer.open !== 'function') return; // cart set to page: keep the normal submit
        e.preventDefault();
        if (adding) return;
        adding = true;
        setBusy(true);

        var root_ = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var sectionId = cartItems.dataset.sectionId;
        var body = new FormData(buyForm);
        body.append('sections', sectionId);
        body.append('sections_url', window.location.pathname);

        fetch(root_ + 'cart/add.js', { method: 'POST', body: body, headers: { Accept: 'application/json' } })
          .then(function(res) {
            if (!res.ok) throw new Error('add failed ' + res.status);
            return res.json();
          })
          .then(function(added) {
            return fetch(root_ + 'cart.js', { headers: { Accept: 'application/json' } })
              .then(function(res) { return res.json(); })
              .then(function(cart) { return { added: added, cart: cart }; });
          })
          .then(function(r) {
            var ev = new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: r.cart,
                sourceId: 'hg-pdp',
                data: {
                  source: 'hg-pdp',
                  itemCount: r.cart.item_count,
                  variantId: String(r.added.variant_id || r.added.id || ''),
                  sections: r.added.sections || {}
                }
              }
            });
            document.dispatchEvent(ev);
            var dialog = drawer.querySelector('dialog');
            if (!dialog || !dialog.open) drawer.open();
            adding = false;
            setBusy(false);
          })
          .catch(function() {
            adding = false;
            setBusy(false);
            nativeSubmit();
          });
      });
    }

    // ===== Intro: two-line preview; "Read more" swaps in the full,
    // formatted description. Without one, it unclamps the preview, and
    // shows only when the preview is actually cut off. =====
    var sub = root.querySelector('[data-sub]');
    var subFull = root.querySelector('[data-sub-full]');
    var subMore = root.querySelector('[data-sub-more]');
    if (sub && subMore) {
      var subOpen = false;
      var checkSub = function() {
        if (subOpen) return;
        var cut = sub.scrollHeight > sub.clientHeight + 1;
        var more = subFull && subFull.textContent.replace(/\s+/g, ' ').trim().length > sub.textContent.trim().length;
        subMore.hidden = !(cut || more);
      };
      subMore.addEventListener('click', function() {
        subOpen = !subOpen;
        if (subFull) {
          subFull.hidden = !subOpen;
          sub.hidden = subOpen;
        } else {
          sub.classList.toggle('is-clamped', !subOpen);
        }
        subMore.textContent = subOpen ? 'Show less' : 'Read more';
        subMore.setAttribute('aria-expanded', subOpen ? 'true' : 'false');
      });
      checkSub();
      window.addEventListener('resize', checkSub);
      window.addEventListener('load', checkSub); // fonts can change line breaks
    }

    // ===== FAQ: first item open =====
    var firstFaq = root.querySelector('[data-faq-list] details');
    if (firstFaq) firstFaq.open = true;

    // ===== In-page nav =====
    var nav = root.querySelector('[data-pdp-nav]');
    var navLinks = root.querySelectorAll('[data-nav-link]');
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    navLinks.forEach(function(link) {
      link.addEventListener('click', function(e) {
        var target = document.getElementById(link.getAttribute('href').slice(1));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      });
    });

    if ('IntersectionObserver' in window) {
      // Active link follows the section crossing the upper part of the viewport.
      var targets = root.querySelectorAll('[data-nav-target]');
      var activeObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) return;
          navLinks.forEach(function(link) {
            link.classList.toggle('is-active', link.getAttribute('href') === '#' + entry.target.id);
          });
        });
      }, { rootMargin: '-25% 0px -65% 0px', threshold: 0 });
      targets.forEach(function(target) { activeObserver.observe(target); });

      // Small screens: the nav is a bottom bar, shown once the main button is
      // off screen and tucked away again at the closing band. Desktop: a
      // separate bar shows only while the button is entirely below the screen
      // and the nav has not reached the top yet (a half-visible button gets
      // no second button under it).
      var bottomCta = root.querySelector('[data-bottom-cta]');
      var bar = root.querySelector('[data-pdp-bar]');
      if (nav && ctaBtn) {
        var heroVisible = true;
        var bottomVisible = false;
        var sync = function() {
          var show = !heroVisible && !bottomVisible;
          var small = window.innerWidth <= 860;
          nav.classList.toggle('is-visible', show);
          document.body.classList.toggle('hg-has-sticky-cta', show && small);
          if (bar) {
            var ctaBelow = ctaBtn.getBoundingClientRect().top >= window.innerHeight;
            var navStuck = nav.getBoundingClientRect().top <= (parseFloat(getComputedStyle(nav).top) || 0) + 1;
            var showBar = !small && ctaBelow && !navStuck && !bottomVisible;
            bar.classList.toggle('is-visible', showBar);
            bar.setAttribute('aria-hidden', showBar ? 'false' : 'true');
          }
        };
        new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) { heroVisible = entry.isIntersecting; });
          sync();
        }, { threshold: 0 }).observe(ctaBtn);
        var ticking = false;
        var onScroll = function() {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(function() { ticking = false; sync(); });
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll);
        sync();
        if (bottomCta) {
          new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) { bottomVisible = entry.isIntersecting; });
            sync();
          }, { threshold: 0, rootMargin: '0px 0px -80px 0px' }).observe(bottomCta);
        }
      }
    }
  });
})();
